import request from '@/utils/request'

// 新增购物车
export function getProductList(data) {
  return request({
    url: '/server/ship/product',
    method: 'GET',
    params: data
  })
}
// 新增购物车
export function getDesignList(data) {
  return request({
    url: '/server/ship/design',
    method: 'GET',
    params: data
  })
}

// 查询支持的物流方式
export function getShip(data) {
  return request({
    url: '/server/ship/get',
    method: 'POST',
    data: data
  })
}

// 计算成本
export function calculateCost(data) {
  return request({
    url: '/server/ship/calculate',
    method: 'POST',
    data: data
  })
}

// 计算成本
export function calculateByPro(data) {
  return request({
    url: '/server/ship/calculateByPro',
    method: 'POST',
    data: data
  })
}